import React, { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { BsPlusLg } from "react-icons/bs";
import { Container, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, Col } from "reactstrap";
import CreateTableComponent from '../../../share/CreateTableComponent';
import { Formik, Form, Field } from "formik";
import { Loading } from "../../../share/loading";
import { v4 as uuidv4 } from "uuid";
import * as Yup from "yup";
import { NumberWithCommas } from "../../../share/NumberWithCommas";
import "../../../share/form.css";
import Swal from "sweetalert2";
import { NumericFormat } from 'react-number-format';
import { CustomInputNumeric } from "../../../share/CustomInputNumeric";
import { FormikSelect } from "../../../share/FormikSelect";
import DatePicker from "react-datepicker";
import { ConvertDateFormat } from "../../../share/ConvertDateFormat";
import { ConvertDateToThaiBuddhist } from "../../../share/ConvertDateToThaiBuddhist";
import { RenderCustomHeader } from "../../../share/RenderCustomHeader";
import { GetVMdDept } from "../../../share/api/MasterDataApi";
// import DataRegisterComponent from "../../../share/DataRegisterComponent";
// import Select from 'react-select';
export function SupportAnnounce11Component() {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const formikRef = useRef(null); // ✅ ใช้ useRef เพื่อดึง setFieldValue ภายนอก
    let supportId = searchParams.get("req");
    let supportTypeId = searchParams.get("type"); //type1 : ประกาศ 4, type2: ประกาศ 5 , type3 : ประกาศ 11

    const [currentSupportForm, setCurrentSupportForm] = useState(null);
    const [loading, setLoading] = useState(false);
    const [userProfile, setUserProfile] = useState(null);
    const [userAuthRegister, setUserAuthRegister] = useState([]);
    const [conditionData, setConditionData] = useState([]);


    // สำหรับใส่ที่อยู่สถานที่ตั้งศูนย์ดำเนินการทดสอบ
    const [testProvince, setTestProvince] = useState([]);
    const [testAmphur, setTestAmphur] = useState([]);
    const [testTumbon, setTestTumbon] = useState([]);

    const [lawOcuData, setLawOcuData] = useState([]);
    const [testLawOcuData, setTestLawOcuData] = useState([]);

    const [dataAnnounce11, setDataAnnounce11] = useState([]);
    // console.log("dataAnnounce11", dataAnnounce11);
    // ดึง cookie มาใช้
    const user = JSON.parse(localStorage.getItem("userData"));
    // state ดึงข้อมูลจาก master data
    const [deptsData, setDeptsData] = useState([]);
    const [titleName, setTitleName] = useState([]);

    //state ประกาศ 11
    const [openModalAnnounce11, setOpenModalAnnounce11] = useState(false);
    const modalToggleAnnounce11 = () => setOpenModalAnnounce11(!openModalAnnounce11);

    const [selectAnnounce11Item, setSelectAnnounce11Item] = useState(null);
    const [isAnnounce11Editing, setIsAnnounce11Editing] = useState(false);

    const [conditionDate, setConditionDate] = useState(null);
    const [calculateAmount, setCalculateAmount] = useState(0);
    // console.log("calculateAmount", calculateAmount);
    useEffect(() => {
        GetVMdDept({ setDeptsData, setLoading })
        GetProvince();
        GetTitleName();
        GetLawOcu();
        getProfile();
        getCondition(3);
        // GetLawOccupationRate()
    }, []);

    const ReplaceNullWithEmptyString = (obj) => {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (obj[key] === null) {
                    obj[key] = '';
                }
            }
        }
        return obj;
    }

    useEffect(() => {
        GetAmphur(userProfile?.address?.provinceCode);
        GetTumbon(userProfile?.address?.provinceCode, userProfile?.address?.amphurCode);
    }, [userProfile])

    async function GetAmphur(provinceCode) {
        let postData = new FormData();
        postData.append("provinceCode", provinceCode);

        try {
            const responseAmphur = await fetch("/api/MasterData/getAmphur", {
                method: "POST",
                body: postData
            });
            const amphurData = await responseAmphur.json()
            setTestAmphur(amphurData.dataenum);
            // console.log(amphurData.dataenum);

        } catch (err) {
            // console.log("err =>" + err);
        }
    }

    const getProfile = async () => {
        try {
            const res = await fetch("/api/Profile/getProfile", {
                method: "POST",
                headers: { 'token': user.token },
            })
            const resJson = await res.json();

            resJson.dataenum.authorizedList = resJson.dataenum.authRegister;
            setUserProfile(resJson.dataenum);
            setUserAuthRegister(resJson.dataenum.authRegister);
            if (supportId == "0") {
                // ✅ ใช้ setFieldValue ผ่าน formikRef
                formikRef.current?.setFieldValue("deptId", resJson.dataenum.deptId);
                formikRef.current?.setFieldValue("coordinateName", resJson.dataenum.contactorName);
                formikRef.current?.setFieldValue("coordinatePhone", resJson.dataenum.contactorPhone);
                formikRef.current?.setFieldValue("coordinateMobile", resJson.dataenum.phone);
                formikRef.current?.setFieldValue("coordinateFax", resJson.dataenum.fax);
                formikRef.current?.setFieldValue("coordinateEmail", resJson.dataenum.email);
            }

        } catch (e) {
            // console.log("err", e)
        }
    };

    const getCondition = async (id) => {
        try {
            let res = await fetch(`api/SupportForm/getConditionSupport/${3}`)
            let resJson = await res.json();
            let [firstArray] = resJson.dataenum;
            setConditionDate(firstArray.conditionDate);
            return resJson.dataenum;
        } catch (e) {
            // console.log('err => ', e)
        }
    }

    // ดึง master data จังหวัด
    async function GetProvince() {
        setLoading(true);
        try {
            const responseProvince = await fetch("/api/MasterData/getProvince");
            const localtionData = await responseProvince.json();
            setTestProvince(localtionData.dataenum);
        } catch (e) {
            // console.log("err => " + e);
        } finally {
            setLoading(false);
        }
    }

    async function GetTumbon(provinceCode, amphurCode) {
        let postData = new FormData();
        postData.append("provinceCode", provinceCode);
        postData.append("amphurCode", amphurCode);
        try {
            let responseTumbon = await fetch("/api/MasterData/getTumbon", {
                method: "POST",
                body: postData
            });
            const tumbonData = await responseTumbon.json()
            setTestTumbon(tumbonData.dataenum);

        } catch (err) {
            // console.log("err =>" + err);
        }
    };

    //ดึงข้อมูลแบบฟอร์มอุดหนุน
    useEffect(() => {
        const GetCurrentSupportForm = async () => {
            if (supportId !== "0") {
                let postData = new FormData();
                postData.append("supportId", Number(supportId));
                postData.append("supportTypeId", Number(supportTypeId));
                setLoading(true);
                try {
                    let res = await fetch("/api/SupportForm/getSupportFormData", {
                        method: "POST",
                        body: postData
                    })
                    let resJson = await res.json();
                    resJson.dataenum["customerTypeId"] = Number(user.roldId);
                    resJson.dataenum["registerId"] = Number(user.registerId);
                    resJson.dataenum["term"] = true;
                    await getCondition(3)
                    resJson.dataenum["announce"] = "11";
                    setDataAnnounce11(resJson?.dataenum?.dataAnnounce11 ?? []);
                    setCurrentSupportForm(ReplaceNullWithEmptyString(resJson.dataenum));
                    await GetAmphur(resJson.dataenum.testProvinceCode);
                    await GetTumbon(resJson.dataenum.testProvinceCode, resJson.dataenum.testAmphurCode)
                } catch (e) {
                    // console.log("err", e);
                } finally {
                    setLoading(false);
                }
            } else {
                return;
            }
        };
        GetCurrentSupportForm();
    }, [])

    useEffect(() => {
        async function getConditionFromAnnounce() {
            conditionData.map((data) => {
                // console.log("data", data);
                setConditionDate(data.conditionDate)
            })
        }
        getConditionFromAnnounce()
    }, [conditionData])

    //calculate announce11
    useEffect(() => {
        async function calculateAmountSupportAnnounce11() {
            setCalculateAmount(0)
            // console.log("dataAnnounce11", dataAnnounce11);
            let sumAmount = dataAnnounce11.map(({ amountTotal }) => amountTotal).reduce((prev, current) => Number(prev) + Number(current))
            setCalculateAmount(sumAmount)
        }
        calculateAmountSupportAnnounce11();
    }, [dataAnnounce11])


    async function GetLawOcu() {
        setLoading(true);
        try {
            const res = await fetch("/api/Borrow/getLawOcuData");
            const data = await res.json();
            setLawOcuData(data.dataenum);
            // console.log(data.dataenum);
        } catch (e) {
            // console.log("e => " + e);
        } finally {
            setLoading(false);
        }
    }

    async function GetTitleName() {
        const res = await fetch("/api/MasterData/getTitle");
        const data = await res.json();
        setTitleName(data.dataenum);
    }

    const initialValues = {
        // กรณีเลือกประกาศข้อ 5
        // detailAnnounce5Ar: dataAnnounce5,
        // กรณีเลือกประกาศข้อ 11
        authRegisterId: 0,
        detailAnnounce11Ar: dataAnnounce11,
        supportId: "0",
        roldId: "",
        registerId: Number(user.registerId),
        deptId: "",
        supportTypeId: "3",
        customerTypeId: Number(user.roldId),
        amount: calculateAmount,
        paymentName: "",
        fOtherPath: "",
        term: "",

    };

    const onSubmit = async (values) => {
        if(values.authRegisterId == 0 || values.authRegisterId == null){
            Swal.fire({
                icon: "warning",
                title: `ไม่สามารถบันทึกข้อมูลได้`,
                allowOutsideClick: false,
                allowEscapeKey: false,
                text: `กรุณาเลือกผู้มีอำนาจ`,
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            });
            return;
        }
        if (calculateAmount === 0) {
            Swal.fire({
                icon: "info",
                title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                text: "",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            });
        } else {
            let postData = new FormData();

            postData.append("amount", calculateAmount)
            Object.entries(values).forEach(([key, value]) => {
                if (key.endsWith("11Ar")) {
                    if (dataAnnounce11.length > 0) {
                        postData.append(key, JSON.stringify(dataAnnounce11));
                    }
                } else {
                    postData.append(key, value);
                }
            });

            try {
                let res = await fetch("/api/SupportForm/saveSupportForm", {
                    method: "POST",
                    body: postData,
                });

                let resJson = await res.json();
                // console.log(resJson.dataenum);

                if (resJson.status === 1) {
                    Swal.fire({
                        icon: "success",
                        title: "บันทึกข้อมูลสำเร็จ",
                        text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate("/supporting/")
                        }
                    });
                } else if (resJson.status === 4) {
                    Swal.fire({
                        icon: "warning",
                        title: "บันทึกข้อมูลไม่สำเร็จ",
                        text: `เนื่องจาก ${resJson.message}`,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "บันทึกข้อมูลไม่สำเร็จ",
                        text: `เนื่องจาก ${resJson.message}`,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    });
                }
            } catch (e) {
                // console.log(e);
            }
        }
    };

    const authRegisterOptions = userAuthRegister?.map((item) => ({
        label: item.authFullName,
        value: item.authRegisterId
    })) || [];

    const validationSchema = Yup.object().shape({

        fOtherPath: Yup.mixed().nullable().when('file', {
            is: value => value !== undefined && value !== null,
            then: Yup.mixed()
                .test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', value => {
                    return value && ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type);
                })
                .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 1MB', value => {
                    const maxSize = 1000000;
                    return !value || value.size <= maxSize;
                }),
        }),
        // supportId: Yup.number(),
        deptId: Yup.string().required("กรุณาเลือกหน่วยงานที่ยื่นคำขอ"),
        // supportName: Yup.string().required("กรุณากรอกชื่อผู้ขอรับเงิน"),

        amount: Yup.number().nullable(),
        paymentName: Yup.string().nullable().required("กรุณากรอก"),
        term: Yup.bool().oneOf([true], "กรุณายอมรับข้อตกลง"),
    });

    async function GetTestLawOnEdit(law) {
        let postData = new FormData();
        postData.append("lawOcuId", law);
        try {
            const res = await fetch("/api/Borrow/getLawOcuDataDetail", {
                method: "POST",
                body: postData,
            });
            const data = await res.json();
            // console.log("law occupation data", data.dataenum);
            setTestLawOcuData(data.dataenum.map((item) => ({
                value: item.testOccupationCode,
                label: item.testOccupationName
            })))
        } catch (e) {
            // console.log("e => " + e);
        }

    }

    async function GetTestLawOcuDetail(law) {
        let postData = new FormData();
        postData.append("lawOcuId", law);
        try {
            const res = await fetch("/api/Borrow/getLawOcuDataDetail", {
                method: "POST",
                body: postData,
            });
            const data = await res.json();
            return data.dataenum
        } catch (e) {
            // console.log("e => " + e);
        }
    }

    // ประกาศ11
    const announce11OnEdit = async (row) => {
        // console.log("row", row)
        await GetTestLawOnEdit(row.lawOcupationId)
        setSelectAnnounce11Item(row);
        setIsAnnounce11Editing(true);
        modalToggleAnnounce11(!openModalAnnounce11)
        // console.log("row", row)
    }
    const announce11OnDelete = async (row) => {
        setDataAnnounce11((current) => current.filter((obj) => {
            return obj.id !== row.id
        }))
    }
    const announce11InititalValues = {
        id: "",
        lawOcupationId: "", //สาขาอาชีพ
        lawOccupationName: "", //ชื่อสาขาอาชีพ
        testOcupationId: "", //สาขา
        testOccupationName: "", //ชื่อสาขา
        amountTotal: "", // เป็นจำนวนเงิน(บาท)
        reciept: "", //เล่มที่ของใบเสร็จรับเงิน
        recieptNo: "", //เลขที่ใบเสร็จรับเงิน
        recieptDate: "", //วันที่ของใบเสร็จรับเงิน
        personTotal: "",
    }
    const announce11ValidateSchema = Yup.object().shape({
        lawOcupationId: Yup.string().required("กรุณาเลือกสาขาอาชีพ"),
        testOcupationId: Yup.string().required("กรุณาเลือกสาขา"),
        amountTotal: Yup.string().required("กรุณากรอกจำนวนเงิน"), // เป็นจำนวนเงิน(บาท)
        // reciept: Yup.string().required("กรุณากรอกเล่มที่ใบเสร็จรับเงิน"), //เล่มที่ของใบเสร็จรับเงิน
        recieptNo: Yup.string()
            .matches(/^มฐ/, "เลขที่ใบเสร็จรับเงินต้องขึ้นต้นด้วย มฐ")
            .required("กรุณากรอกเลขที่ใบเสร็จรับเงิน"), //เลขที่ใบเสร็จรับเงิน
        recieptDate: Yup.date().required("กรุณากรอกวันที่ใบเสร็จรับเงิน"), //วันที่ของใบเสร็จรับเงิน
        personTotal: Yup.string().required("กรุณากรอกจำนวนคน")
    })
    const announce11Onsubmit = async (values) => {

        const { lawOcupationId, testOcupationId } = values
        let getTestOccupationName;
        let getLawOccupationName;

        let getSupType = await GetTestLawOcuDetail(lawOcupationId)

        getSupType.forEach((type) => {
            if (type.testOccupationCode == testOcupationId) {
                getTestOccupationName = type.testOccupationName
            }
        })
        // console.log("getSupType",getSupType )

        lawOcuData.forEach((item, i) => {
            if (item.lawOccupationId == lawOcupationId) {
                getLawOccupationName = item.lawOccupationName
            }
        })

        if (values.id !== "") {
            setDataAnnounce11((old) =>
                old.map((row) => {
                    if (row.id === values.id) {
                        return {
                            ...values,
                            id: values.id,
                        };
                    }
                    return row;
                })
            );
            modalToggleAnnounce11(!openModalAnnounce11)
        } else {
            let pre = {
                ...values,
                testOccupationName: getTestOccupationName,
                lawOccupationName: getLawOccupationName,
                id: uuidv4()
            }
            setDataAnnounce11((prev) => [...prev, pre]);
            modalToggleAnnounce11(!openModalAnnounce11)
        }

    }
    const COLUMNSANNOUNCE11 = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1,
        },
        {
            Header: "จำนวนเงิน (บาท)",
            accessor: "amountTotal",
            Cell: ({ row }) => {
                return (
                    <>{NumberWithCommas(row.original.amountTotal)}</>
                );
            },
        },
        {
            Header: "เลขที่ใบเสร็จรับเงิน",
            accessor: "recieptNo",
        },
        {
            Header: "รายละเอียด",
            accessor: "id",
            Cell: ({ row }) => {
                return (
                    <div className="text-center">
                        <button
                            type="button"
                            className="btn border border-1 mx-1"
                            onClick={() =>
                                announce11OnEdit(row.original)
                            }
                        >
                            แก้ไข
                        </button>
                        <button
                            type="button"
                            className="btn border border-1 mx-1"
                            onClick={() =>
                                announce11OnDelete(row.original)
                            }
                        >
                            ลบ
                        </button>
                    </div>
                );
            },
        },
    ];

    return (
        <Formik
            innerRef={formikRef} // ✅ ตรงนี้สำคัญ
            initialValues={supportId === "0" ? initialValues : currentSupportForm}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize={supportId === "0" ? false : true}
        >
            {({ setFieldValue, values, touched, errors, handleBlur, handleChange, getFieldProps }) => {
                const findPersonalId = () => {
                    if (values?.authRegisterId != 0) {
                        const found = userAuthRegister.find(item => item.authRegisterId == values?.authRegisterId);
                        return found?.authPersonalId ?? "-"
                    }
                }
                return (
                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        {!loading ? (
                            <div className="form-border">
                                <Form className="p-5 mb-4">

                                    <Label className="customer-type text-center px-5">
                                        คำขอรับเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน
                                        พ.ศ. 2545 กรมพัฒนาฝีมือแรงงาน กระทรวงแรงงาน
                                    </Label>

                                    <Label className="mb-3 input-color">ข้อมูลผู้ขอเงินช่วยเหลือหรืออุดหนุน</Label>
                                    {/* <DataRegisterComponent /> */}
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน

                                        </Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                // name="authoriseName"
                                                // id="authoriseName"
                                                // placeholder="กรุณากรอกชื่อ-สกุล"
                                                onBlur={handleBlur}
                                                // onChange={(e) => {
                                                //     handleChange(e);
                                                // }}
                                                value={userProfile?.licenseTestName ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            เลขทะเบียนนิติบุคคล
                                        </Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                // name="authoriseName"
                                                // id="authoriseName"
                                                // placeholder="กรุณากรอกชื่อ-สกุล"
                                                onBlur={handleBlur}
                                                // onChange={(e) => {
                                                //     handleChange(e);
                                                // }}
                                                value={userProfile?.customerNo ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>

                                    <Label className="mb-3 input-color">กรุณากรอกรายละเอียดการขอเงินช่วยเหลือหรืออุดหนุน</Label>
                                    {/* input เลือกหน่วยงานที่จะยื่นคำขอ */}
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            ยื่นคำขอที่
                                            <span className="require-input">*</span>
                                            {touched.deptId && errors.deptId ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.deptId}
                                                </span>
                                            ) : null}
                                        </Label>
                                        <Col>
                                            <Field
                                                name="deptId"
                                                component={FormikSelect}
                                                options={deptsData}
                                                placeholder={<div className="input-color text-center">กรุณาเลือกหน่วยงาน</div>}
                                            />
                                        </Col>
                                    </FormGroup>



                                    {/* ผู้กระทำการแทน คำนำหน้าและชื่อ */}
                                    <FormGroup row>
                                        <Label for="titleId">
                                            โดย (ผู้มีอำนาจกระทำการแทน/ผู้รับมอบอำนาจ)
                                            <span className="require-input">*</span>
                                            {touched?.authRegisterId &&
                                                errors?.authRegisterId ? (
                                                <span className="text-left text-danger px-1">
                                                    {errors?.authRegisterId}
                                                </span>
                                            ) : null}

                                        </Label>
                                        <div className="d-flex justify-content-start ">
                                            <div className="flex-grow-1">
                                                <Field
                                                    name="authRegisterId"
                                                    component={FormikSelect}
                                                    options={authRegisterOptions}
                                                    placeholder={<div className="input-color text-center">กรุณาเลือก</div>}
                                                />
                                            </div>

                                        </div>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="titleId">
                                            เลขบัตรประจำตัวประชาชน

                                        </Label>

                                        <div className="d-flex justify-content-start ">
                                            <div className="flex-grow-1">
                                                <Input
                                                    className="rounded-pill text-center input-color"
                                                    type="text"
                                                    name=""
                                                    id=""
                                                    disabled
                                                    value={findPersonalId()}
                                                />

                                            </div>
                                        </div>
                                    </FormGroup>


                                    {/* ที่ตั้ง ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน */}
                                    <div className="pt-3">
                                        <Label for="">
                                            ที่ตั้ง ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน
                                        </Label>
                                        {/* ที่อยู่ */}
                                        <div className="px-3 pt-4">
                                            <FormGroup row>
                                                <Label for="testAddressNo" sm={2}>
                                                    เลขที่<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="testAddressNo"
                                                        name="testAddressNo"
                                                        disabled
                                                        type="text"
                                                        className={
                                                            touched.testAddressNo && errors.testAddressNo
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        // value={values?.testAddressNo}
                                                        value={userProfile?.address?.addressNo ?? "-"}
                                                    />
                                                </Col>

                                                <Label for="testMoo" sm={2}>
                                                    หมู่ที่
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="testMoo"
                                                        name="testMoo"
                                                        disabled
                                                        type="text"
                                                        className="rounded-pill text-center input-color"
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        // value={values?.testMoo}
                                                        value={userProfile?.address?.moo ?? "-"}
                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label for="testSoi" sm={2}>
                                                    ซอย
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="testSoi"
                                                        name="testSoi"
                                                        disabled
                                                        type="text"
                                                        className={
                                                            touched.testSoi && errors.testSoi
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        // value={values?.testSoi}
                                                        value={userProfile?.address?.soi ?? "-"}

                                                    />
                                                </Col>

                                                <Label for="" sm={2}>
                                                    ถนน
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="testStreet"
                                                        name="testStreet"
                                                        disabled
                                                        type="text"
                                                        className={
                                                            touched.testStreet && errors.testStreet
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        // value={values?.testStreet}
                                                        value={userProfile?.address?.street ?? "-"}

                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label for="testProvinceCode" sm={2}>
                                                    จังหวัด<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="testProvinceCode"
                                                        name="testProvinceCode"
                                                        disabled
                                                        value={userProfile?.address?.provinceCode ?? "-"}
                                                        type="select"
                                                        className={
                                                            touched.testProvinceCode &&
                                                                errors.testProvinceCode
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                    // onChange={(e) => {
                                                    //     handleChange(e);
                                                    //     GetTestAmphur(e);
                                                    //     setFieldValue("testAmphurCode", "กรุณาเลือกอำเภอ/เขต");
                                                    //     setFieldValue("testTumbonCode", "กรุณาเลือกตำบล/แขวง");
                                                    // }}
                                                    // value={values?.testProvinceCode}
                                                    >
                                                        <option defaultValue="กรุณาเลือกจังหวัด">
                                                            กรุณาเลือกจังหวัด
                                                        </option>
                                                        {testProvince?.map((province) => (
                                                            <option
                                                                key={province.provinceCode}
                                                                value={province.provinceCode}
                                                            >
                                                                {province.provinceName}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </Col>

                                                <Label for="testAmphurCode" sm={2}>
                                                    อำเภอ/เขต<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="testAmphurCode"
                                                        name="testAmphurCode"
                                                        disabled
                                                        type="select"
                                                        className={
                                                            touched.testAmphurCode &&
                                                                errors.testAmphurCode
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        // onChange={(e) => {
                                                        //     handleChange(e);
                                                        //     GetTestTumbon(e);
                                                        //     setFieldValue(
                                                        //         "testTumbonCode",
                                                        //         "กรุณาเลือกตำบล/แขวง"
                                                        //     );
                                                        // }}
                                                        // value={values?.testAmphurCode}
                                                        value={userProfile?.address?.amphurCode ?? "-"}

                                                    >
                                                        <option defaultValue="กรุณาเลือกอำเภอ/เขต">
                                                            กรุณาเลือกอำเภอ/เขต
                                                        </option>
                                                        {testAmphur?.map((amphur) => (
                                                            <option
                                                                key={amphur.amphurCode}
                                                                value={amphur.amphurCode}
                                                            >
                                                                {amphur.amphurName}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label for="testTumbonCode" sm={2}>
                                                    ตำบล/แขวง<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="testTumbonCode"
                                                        name="testTumbonCode"
                                                        disabled
                                                        type="select"
                                                        className={
                                                            touched.testTumbonCode &&
                                                                errors.testTumbonCode
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        // onChange={(e) => {
                                                        //     handleChange(e);
                                                        //     GetTestLocationsId(e);
                                                        // }}
                                                        // value={values?.testTumbonCode}
                                                        value={userProfile?.address?.tumbonCode ?? "-"}

                                                    >
                                                        <option defaultValue="กรุณาเลือกตำบล/แขวง">
                                                            กรุณาเลือกตำบล/แขวง
                                                        </option>
                                                        {testTumbon?.map((tumbon) => (
                                                            <option
                                                                key={tumbon.tumbonCode}
                                                                value={tumbon.tumbonCode}
                                                            >
                                                                {tumbon.tumbonName}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </Col>

                                                <Label for="testPostCode" sm={2}>
                                                    รหัสไปรษณีย์<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        maxLength={5}
                                                        id="testPostCode"
                                                        name="testPostCode"
                                                        type="text"
                                                        disabled
                                                        className={
                                                            touched.testPostCode && errors.testPostCode
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        // value={values?.testPostCode}
                                                        value={userProfile?.address?.postCode ?? "-"}

                                                    />
                                                </Col>
                                            </FormGroup>

                                        </div>
                                    </div>



                                    {/* ชื่อผู้ประสานงาน */}
                                    <FormGroup>
                                        <Label for="contact">
                                            ชื่อผู้ประสานงาน
                                            <span className="require-input">*</span>

                                        </Label>
                                        <Col>
                                            <Input
                                                className={
                                                    touched.coordinateName && errors.coordinateName
                                                        ? "input-error rounded-pill text-center input-color"
                                                        : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="coordinateName"
                                                id="coordinateName"
                                                onBlur={handleBlur}
                                                disabled
                                                onChange={(e) => {
                                                    handleChange(e);
                                                }}
                                                value={values?.coordinateName}
                                            // value={userProfile?.coordinateName}


                                            />
                                        </Col>
                                        <div className="px-3 pt-4">
                                            <FormGroup row>
                                                <Label for="coordinatePhone" sm={2}>
                                                    โทรศัพท์<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinatePhone"
                                                        name="coordinatePhone"
                                                        type="text"
                                                        className={
                                                            touched.coordinatePhone &&
                                                                errors.coordinatePhone
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        disabled
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        value={values?.coordinatePhone}
                                                    />
                                                </Col>

                                                <Label for="coordinateMobile" sm={2}>
                                                    โทรศัพท์มือถือ<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateMobile"
                                                        name="coordinateMobile"
                                                        disabled
                                                        type="text"
                                                        className={
                                                            touched.coordinateMobile &&
                                                                errors.coordinateMobile
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        value={values?.coordinateMobile}
                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label for="soi" sm={2}>
                                                    โทรสาร
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateFax"
                                                        name="coordinateFax"
                                                        disabled
                                                        type="text"
                                                        className={
                                                            touched.coordinateFax && errors.coordinateFax
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        value={values?.coordinateFax}
                                                    />
                                                </Col>

                                                <Label for="coordinateEmail" sm={2}>
                                                    อีเมล<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateEmail"
                                                        name="coordinateEmail"
                                                        disabled
                                                        type="text"
                                                        className={
                                                            touched.coordinateEmail &&
                                                                errors.coordinateEmail
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        value={values?.coordinateEmail}
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </div>
                                    </FormGroup>

                                    {/* ประกาศข้อ 11 */}
                                    <FormGroup className="mt-3">

                                        <Label>
                                            ดำเนินการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติ และส่งเงินค่าทดสอบเข้ากองทุนพัฒนาฝีมือแรงงาน
                                            ตามมาตรา 27

                                            <br />
                                            วรรคสอง (3/1) ตามประกาศข้อ 10
                                        </Label>
                                    </FormGroup>
                                    {/* modal กรอกข้อมูลใบเสร็จ */}
                                    <Formik
                                        initialValues={isAnnounce11Editing ? selectAnnounce11Item : announce11InititalValues}
                                        validationSchema={announce11ValidateSchema}
                                        onSubmit={announce11Onsubmit}
                                        enableReinitialize
                                    >{({ values, handleChange, handleBlur, setFieldValue, setFieldError, setValues, resetForm, errors, touched, submitForm, isValid }) => {
                                        // console.log("errors", errors)
                                        // console.log("isValid", isValid)
                                        // console.log("values", values);
                                        // console.log("conditionDate", conditionDate);

                                        const searchReceipt = async (receiptNo) => {
                                            if (!receiptNo?.trim()) {
                                                Swal.fire({ icon: "warning", title: "กรุณากรอกเลขที่ใบเสร็จ", confirmButtonColor: "#0A66C2" });
                                                return;
                                            }
                                            let formData = new FormData();
                                            formData.append("receiptNo", receiptNo);
                                            try {
                                                let res = await fetch("/api/SupportForm/searchReceiptNo", {
                                                    method: "POST",
                                                    body: formData
                                                })
                                                let resJson = await res.json();
                                                let data = resJson.dataenum;
                                                // console.log("data", data);
                                                if (resJson.status === 0) {
                                                    Swal.fire({ icon: "info", title: `${resJson.message}`, confirmButtonColor: "#0A66C2" });
                                                    return;
                                                }
                                                setFieldValue("recieptNo", data.receiptNo ?? receiptNo);
                                                setFieldValue("amountTotal", data.amount ?? "");
                                                setFieldValue("personTotal", data.personTotal ?? "");
                                                setFieldValue("testOcupationId", data.testOccupationCode ?? "")
                                                setFieldValue("recieptDate", data.createDate)
                                                calculateDate(new Date(data.createDate));
                                                // โหลดตัวเลือกสาขาอาชีพตาม lawOccupationId แล้วค่อย set testOcupationId
                                                const lawId = data.lawOccupationId ?? "";
                                                if (lawId) {
                                                    // ดึงรายการ test occupations (เหมือนใน GetLawOcuDetail แต่เรียกตรง ๆ)
                                                    const postData = new FormData();
                                                    postData.append("lawOcuId", lawId);
                                                    try {
                                                        const res2 = await fetch("/api/Borrow/getLawOcuDataDetail", {
                                                            method: "POST",
                                                            body: postData,
                                                        });
                                                        const d2 = await res2.json();

                                                        // map เป็น [{value,label}]
                                                        const options = (d2?.dataenum ?? []).map((item) => ({
                                                            value: item.testOccupationCode,
                                                            label: item.testOccupationName,
                                                        }));
                                                        setTestLawOcuData(options);

                                                        // เซ็ต testOcupationId จาก API searchReceipt
                                                        if (data.testOccupationCode) {
                                                            const exist = options.find((o) => o.value === data.testOccupationCode);
                                                            if (exist) {
                                                                setFieldValue("testOcupationId", data.testOccupationCode);
                                                            }
                                                        }
                                                    } catch (_) {
                                                        // เงียบหรือแจ้งเตือนเบา ๆ ก็ได้
                                                    }
                                                }
                                                setFieldValue("lawOcupationId", lawId);
                                            } catch (e) {
                                                // console.log("err", e)
                                            }
                                        }

                                        const calculateDate = (date) => {
                                            // console.log("calculateDate date", date);
                                            if (date === null) {
                                                setFieldError("recieptDate", `วันที่มีจำนวนมากกว่า ${conditionDate} วัน `);
                                            } else {
                                                const baseDay = Number(conditionDate) * 24 * 60 * 60 * 1000;
                                                let difference = new Date() - date

                                                if (difference > baseDay) {
                                                    // setFieldError,("recieptDate", true);
                                                    Swal.fire({
                                                        icon: "warning",
                                                        title: `วันที่มีจำนวนมากกว่า ${conditionDate} วัน `,
                                                        text: `กรุณาตรวจสอบข้อมูลอีกครั้ง`,
                                                        confirmButtonColor: "#0A66C2",
                                                        confirmButtonText: "ตกลง",
                                                    }).then(() => {
                                                        setFieldError("recieptDate", `วันที่มีจำนวนมากกว่า ${conditionDate} วัน `);
                                                    });
                                                }
                                            }
                                        }
                                        const onAddAnnoune11Detail = () => {
                                            setIsAnnounce11Editing(false)
                                            setSelectAnnounce11Item(null)
                                            resetForm()
                                            modalToggleAnnounce11();
                                        };
                                        const AddDetailAnnounce11Btn = () => {
                                            return (
                                                <button
                                                    className="btn border border-1 text-white btn-green"
                                                    // style={{backgroundColor:"#0A66C2"}}
                                                    onClick={() => onAddAnnoune11Detail()}
                                                >
                                                    <BsPlusLg className="mx-2" />
                                                    เพิ่ม
                                                </button>
                                            );
                                        };

                                        async function GetLawOcuDetail(e) {
                                            let postData = new FormData();
                                            postData.append("lawOcuId", e.target.value);
                                            try {
                                                const res = await fetch("/api/Borrow/getLawOcuDataDetail", {
                                                    method: "POST",
                                                    body: postData,
                                                });
                                                const data = await res.json();
                                                // console.log(data.dataenum)
                                                // setTestLawOcuData(data.dataenum);
                                                setTestLawOcuData(data.dataenum.map((item) => ({
                                                    value: item.testOccupationCode,
                                                    label: item.testOccupationName
                                                })))
                                            } catch (e) {
                                                // console.log("e => " + e);
                                            }
                                        }


                                        return (
                                            <div className="">

                                                <CreateTableComponent
                                                    column={COLUMNSANNOUNCE11}
                                                    dataInput={dataAnnounce11}
                                                    FormInput={AddDetailAnnounce11Btn}
                                                    showEntrie={false}
                                                    showPage={false}
                                                />

                                                <Modal
                                                    isOpen={openModalAnnounce11}
                                                    toggle={modalToggleAnnounce11}
                                                    size="lg"
                                                    // style={{ maxWidth: "600px", width: "100%" }}
                                                    centered
                                                    scrollable
                                                    className="modal-bordered"
                                                    backdrop={"static"}
                                                    keyboard={false}
                                                >
                                                    <ModalHeader className="styled-modal text-center" toggle={modalToggleAnnounce11}>
                                                        กรุณากรอกข้อมูล
                                                    </ModalHeader>
                                                    <ModalBody className="form-border">
                                                        <div>
                                                            <Form autoComplete="off" className="">
                                                                <div className="p-4">
                                                                    <FormGroup>
                                                                        <Field name="id" disabled={true} className="d-none" />
                                                                        <div>



                                                                            {/* <Label className="mt-2">ตามใบเสร็จรับเงินเล่มที่</Label>
                                                                            {touched.reciept && errors.reciept ? (
                                                                                <span className="text-left text-danger px-1">
                                                                                    {errors.reciept}
                                                                                </span>
                                                                            ) : null}
                                                                            <Field name="reciept">
                                                                                {({ field, meta }) => (
                                                                                    <Input
                                                                                        type="text"
                                                                                        className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                                                        {...field}

                                                                                    />

                                                                                )}
                                                                            </Field> */}

                                                                            <Label className="mt-2">เลขที่ใบเสร็จรับเงิน</Label>
                                                                            {touched.recieptNo && errors.recieptNo ? (
                                                                                <span className="text-left text-danger px-1">{errors.recieptNo}</span>
                                                                            ) : null}

                                                                            <Field name="recieptNo">
                                                                                {({ field, meta }) => {
                                                                                    // ปุ่มค้นหาจะกดได้ก็ต่อเมื่อเลขที่ใบเสร็จขึ้นต้นด้วย มฐ
                                                                                    const canSearch = /^มฐ/.test((field.value || "").trim());
                                                                                    return (
                                                                                    <div className="d-flex gap-2">
                                                                                        <Input
                                                                                            type="text"
                                                                                            className={
                                                                                                meta.touched && meta.error
                                                                                                    ? "input-error rounded-pill text-center input-color"
                                                                                                    : "rounded-pill text-center input-color"
                                                                                            }
                                                                                            {...field}
                                                                                            // กด Enter เพื่อค้นหาได้
                                                                                            onKeyDown={(e) => {
                                                                                                if (e.key === "Enter") {
                                                                                                    e.preventDefault();
                                                                                                    if (canSearch) searchReceipt(field.value);
                                                                                                }
                                                                                            }}
                                                                                            placeholder="กรอกเลขที่ใบเสร็จรับเงิน (ขึ้นต้นด้วย มฐ) เพื่อทำการค้นหา"
                                                                                        />
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn border border-1 text-white btn-green"
                                                                                            onClick={() => searchReceipt(field.value)}
                                                                                            disabled={!canSearch}
                                                                                            style={!canSearch ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
                                                                                            title={canSearch ? "ค้นหาใบเสร็จ" : "เลขที่ใบเสร็จต้องขึ้นต้นด้วย มฐ"}
                                                                                        >
                                                                                            ค้นหา
                                                                                        </button>
                                                                                    </div>
                                                                                    );
                                                                                }}
                                                                            </Field>

                                                                            <Label className="mt-2">ลงวันที่</Label>
                                                                            {touched.recieptDate && errors.recieptDate ? (
                                                                                <span className="text-left text-danger px-1">
                                                                                    {errors.recieptDate}
                                                                                </span>
                                                                            ) : null}
                                                                            <Field name="recieptDate">
                                                                                {({ field, meta, form }) => {
                                                                                    return (
                                                                                        <DatePicker
                                                                                            selected={field.value ? new Date(field.value) : null}
                                                                                            locale="th-buddhist"
                                                                                            calendarClassName="thai-buddhist"
                                                                                            dateFormat="dd MMMM yyyy"
                                                                                            value={ConvertDateToThaiBuddhist(field.value)}
                                                                                            maxDate={new Date()}
                                                                                            isClearable={true}
                                                                                            disabled
                                                                                            placeholderText="กรุณาเลือก"
                                                                                            renderCustomHeader={RenderCustomHeader}
                                                                                            onChange={(date) => {
                                                                                                // console.log("date", date);
                                                                                                form.setFieldValue(field.name, ConvertDateFormat(date))
                                                                                                calculateDate(date);
                                                                                            }}
                                                                                            // disabled
                                                                                            customInput={
                                                                                                <Input
                                                                                                    type="text"
                                                                                                    className={
                                                                                                        touched.recieptDate && errors.recieptDate
                                                                                                            ? "input-error rounded-pill text-center input-color"
                                                                                                            : "rounded-pill text-center input-color"
                                                                                                    }
                                                                                                    value={ConvertDateToThaiBuddhist(field.value)}
                                                                                                    onChange={() => { }}
                                                                                                    onBlur={field.onBlur}
                                                                                                />
                                                                                            }

                                                                                        />
                                                                                    )
                                                                                }}
                                                                            </Field>
                                                                            <Label className="mt-2">สาขาอาชีพ</Label>
                                                                            {touched.lawOcupationId && errors.lawOcupationId ? (
                                                                                <span className="text-left text-danger px-1">
                                                                                    {errors.lawOcupationId}
                                                                                </span>
                                                                            ) : null}
                                                                            <Field name="lawOcupationId">
                                                                                {({ field, meta }) => (
                                                                                    <Input
                                                                                        type="select"
                                                                                        className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                                                        {...field}
                                                                                        disabled
                                                                                        onChange={(e) => {
                                                                                            handleChange(e)
                                                                                            GetLawOcuDetail(e)
                                                                                        }}
                                                                                    >
                                                                                        <option defaultValue={"--กรุณาเลือกสาขาอาชีพ--"}>
                                                                                            --กรุณาเลือกสาขาอาชีพ--
                                                                                        </option>
                                                                                        {lawOcuData.map((lawOcu, index) => (
                                                                                            <option
                                                                                                key={lawOcu.lawOccupationId}
                                                                                                value={lawOcu.lawOccupationId}
                                                                                            >
                                                                                                {lawOcu.lawOccupationName}
                                                                                            </option>
                                                                                        ))}
                                                                                    </Input>
                                                                                )}
                                                                            </Field>

                                                                            <Label className="mt-3">สาขา</Label>
                                                                            {touched.testOcupationId && errors.testOcupationId ? (
                                                                                <span className="text-left text-danger px-1">
                                                                                    {errors.testOcupationId}
                                                                                </span>
                                                                            ) : null}
                                                                            <Field name="testOcupationId">
                                                                                {({ field, meta }) => (
                                                                                    <Input
                                                                                        type="select"
                                                                                        className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                                                        {...field}
                                                                                        disabled
                                                                                    >
                                                                                        <option defaultValue={"--กรุณาเลือกสาขา--"}>
                                                                                            --กรุณาเลือกสาขา--
                                                                                        </option>
                                                                                        {testLawOcuData.map((data, index) => (
                                                                                            <option
                                                                                                key={data.index}
                                                                                                value={data.value}
                                                                                            >
                                                                                                {data.label}
                                                                                            </option>
                                                                                        ))}
                                                                                    </Input>
                                                                                )}
                                                                            </Field>
                                                                            {/* <Field
                                                                                name="testOcupationId"
                                                                                component={FormikSelect}
                                                                                disabled
                                                                                options={testLawOcuData}
                                                                                placeholder={
                                                                                    <div className="input-color text-center">--กรุณาเลือกสาขา--</div>
                                                                                }
                                                                            /> */}

                                                                            <Label className="mt-3">จำนวนคน</Label>
                                                                            {touched.personTotal && errors.personTotal ? (
                                                                                <span className="text-left text-danger px-1">
                                                                                    {errors.personTotal}
                                                                                </span>
                                                                            ) : null}
                                                                            <Field name="personTotal">
                                                                                {({ field, meta, form: { setFieldValue, values } }) => (
                                                                                    <NumericFormat
                                                                                        {...field}
                                                                                        isAllowed={false}
                                                                                        allowLeadingZeros
                                                                                        thousandSeparator=","
                                                                                        decimalScale={2}
                                                                                        isNumericString={true}
                                                                                        displayType="number"
                                                                                        value={values.personTotal}
                                                                                        format={(value) => value.toLocaleString()}
                                                                                        customInput={CustomInputNumeric}
                                                                                        onValueChange={(values, sourceInfo) => {
                                                                                            setFieldValue(field.name, values.value)
                                                                                        }}
                                                                                        disabled
                                                                                        className={meta.error && meta.touched ? "input-error" : ""}
                                                                                    />
                                                                                    // <Input
                                                                                    //   type="text"
                                                                                    //   className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                                                    //   {...field}
                                                                                    // />
                                                                                )}
                                                                            </Field>

                                                                            <Label className="mt-2">จำนวนเงิน</Label>
                                                                            {touched.amountTotal && errors.amountTotal ? (
                                                                                <span className="text-left text-danger px-1">
                                                                                    {errors.amountTotal}
                                                                                </span>
                                                                            ) : null}
                                                                            <Field name="amountTotal">
                                                                                {({ field, meta, form: { setFieldValue, values } }) => (
                                                                                    <NumericFormat
                                                                                        {...field}
                                                                                        isAllowed={false}
                                                                                        allowLeadingZeros
                                                                                        thousandSeparator=","
                                                                                        disabled
                                                                                        decimalScale={2}
                                                                                        isNumericString={true}
                                                                                        displayType="number"
                                                                                        value={values.amountTotal}
                                                                                        format={(value) => value.toLocaleString()}
                                                                                        customInput={CustomInputNumeric}
                                                                                        onValueChange={(values, sourceInfo) => {
                                                                                            setFieldValue(field.name, values.value)
                                                                                        }}
                                                                                        className={meta.error && meta.touched ? "input-error" : ""}
                                                                                    />
                                                                                    // <Input
                                                                                    //   type="text"
                                                                                    //   className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                                                    //   {...field}
                                                                                    // />
                                                                                )}
                                                                            </Field>

                                                                        </div>

                                                                    </FormGroup>
                                                                </div>


                                                                <ModalFooter className="d-flex justify-content-center">
                                                                    <button
                                                                        type="submit"
                                                                        className="btn-blue w-50"
                                                                        disabled={!isValid}

                                                                    // onClick={()=> submitForm()}
                                                                    >
                                                                        บันทึก
                                                                    </button>
                                                                </ModalFooter>
                                                            </Form>
                                                        </div>
                                                    </ModalBody>
                                                </Modal>
                                            </div>
                                        );
                                    }}
                                    </Formik>

                                    {/* แบนไฟล์ต่างๆ */}
                                    <FormGroup className="mt-3">
                                        <Label>
                                            มีความประสงค์ขอรับเงินช่วยเหลืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน
                                            พ.ศ. 2545 เป็นจำนวนเงินทั้งสิ้น
                                            <span className="require-input">*</span>
                                            {touched.amount && errors.amount ? (
                                                <span className="text-left text-danger px-1">
                                                    {errors.amount}
                                                </span>
                                            ) : null}
                                        </Label>
                                        <Input
                                            id="amount"
                                            name="amount"
                                            type="text"
                                            disabled={true}
                                            className={
                                                touched.amount && errors.amount
                                                    ? "input-error rounded-pill text-center input-color"
                                                    : "rounded-pill text-center input-color"
                                            }
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            value={NumberWithCommas(Number(calculateAmount))}
                                        />
                                    </FormGroup>

                                    <FormGroup className="">
                                        <Label>
                                            โดยขอรับเช็คขีดคร่อมสั่งจ่ายในนาม
                                            <span className="require-input">*</span>
                                            {touched.paymentName && errors.paymentName ? (
                                                <span className="text-left text-danger px-1">
                                                    {errors.paymentName}
                                                </span>
                                            ) : null}
                                        </Label>
                                        <Input
                                            id="paymentName"
                                            name="paymentName"
                                            type="text"
                                            className={
                                                touched.paymentName && errors.paymentName
                                                    ? "input-error rounded-pill text-center input-color"
                                                    : "rounded-pill text-center input-color"
                                            }
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            value={values?.paymentName}
                                        />
                                    </FormGroup>

                                    {/* <FormGroup className="">
                                        <Label>
                                            หนังสือมอบอำนาจพร้อมติดอากรแสตมป์ (กรณีมอบอำนาจ)
                                        </Label>
                                        <Input
                                            id="fAuthrisePath"
                                            name="fAuthrisePath"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                                if (e.target && e.target.files[0]) {
                                                    setFieldValue("fAuthrisePath", e.target.files[0]);
                                                }
                                            }}
                                        />
                                    </FormGroup> */}

                                    {/* <FormGroup className="">
                                        <Label for="fAuthriseIdCardPath">
                                            สำเนาบัตรประชาชนของผู้มอบอำนาจ (กรณีมอบอำนาจ)
                                        </Label>
                                        <Input
                                            id="fAuthriseIdCardPath"
                                            name="fAuthriseIdCardPath"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                                if (e.target && e.target.files[0]) {
                                                    setFieldValue("fAuthriseIdCardPath", e.target.files[0]);
                                                }
                                            }}
                                        />
                                    </FormGroup> */}

                                    {/* <FormGroup className="">
                                        <Label>
                                            บัตรประจำตัวประชาชน (กรณีบุคคลธรรมดา)
                                            {user.roldId === "2" ? (
                                                <span className="require-input">*</span>
                                            ) : null}

                                            {touched.fIdCardPath && errors.fIdCardPath ? (
                                                <span className="text-left text-danger px-1">
                                                    {errors.fIdCardPath}
                                                </span>
                                            ) : null}
                                        </Label>
                                        <Input
                                            id="fIdCardPath"
                                            name="fIdCardPath"
                                            type="file"
                                            className={
                                                touched.fIdCardPath && errors.fIdCardPath
                                                    ? "input-error rounded-pill text-center input-color"
                                                    : "rounded-pill text-center input-color"
                                            }
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                                if (e.target && e.target.files[0]) {
                                                    setFieldValue("fIdCardPath", e.target.files[0]);
                                                }
                                            }}
                                        />
                                    </FormGroup> */}

                                    <FormGroup>
                                        <Label>เอกสารอื่นๆ (ถ้ามี)</Label>
                                        <Input
                                            id="fOtherPath"
                                            name="fOtherPath"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                                if (e.target && e.target.files[0]) {
                                                    setFieldValue("fOtherPath", e.target.files[0]);
                                                }
                                            }}
                                        />
                                    </FormGroup>

                                    {/* term */}
                                    <div className="d-flex">
                                        <Input
                                            type="checkbox"
                                            name="term"
                                            id="term"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            value={values?.term}
                                            checked={values?.term}
                                        />
                                        <Label for="term" className="mx-2 customer-type">
                                            ข้าพเจ้ารับรองว่าข้อความดังกล่าวข้างต้นและเอกสารหลักฐานที่แนบคำขอถูกต้องและเป็นความจริงทุกประการ
                                        </Label>
                                    </div>
                                    <FormGroup className="d-flex justify-content-center mt-3">
                                        <button
                                            type="submit"
                                            disabled={values?.term ? false : true}
                                            className="btn-blue px-4 w-25"
                                        >
                                            ส่งคำขอ
                                        </button>
                                    </FormGroup>

                                </Form>
                            </div>
                        ) : (
                            <Loading />
                        )}
                    </Container>
                );
            }}
        </Formik>
    );
}
